// The one person demo mode is about. Every fixture builds on these values so the
// account reads as a single coherent human across every page.

export const DEMO_PERSON_ID = 903117;
export const DEMO_EMAIL = 'demo@dundermifflin.com';

export const DEMO_PERSONA = {
    id: DEMO_PERSON_ID,
    first_name: 'Michael',
    last_name: 'Scott',
    full_name: 'Michael Scott',
    email: DEMO_EMAIL,
    dob: '1964-03-15',
    phone: '+15705550142',
    company: 'Dunder Mifflin',
    address: {
        line_1: '1725 Slough Avenue',
        line_2: 'Suite 200',
        city: 'Scranton',
        region: 'PA',
        state: 'PA',
        postal_code: '18505',
        country: 'US',
    },
    member_since: '2023-04-11T14:02:00.000Z',
    risk_score: 72,
} as const;

/** Deterministic ISO timestamp `days` before now — fixtures must never drift into the future. */
export function demoDaysAgo(days: number): string {
    return new Date(Date.now() - days * 24 * 60 * 60 * 1000).toISOString();
}

/** Deterministic ISO timestamp `days` after now, for renewals and expiries. */
export function demoDaysAhead(days: number): string {
    return new Date(Date.now() + days * 24 * 60 * 60 * 1000).toISOString();
}
